import HttpService from "~/Scripts/services/httpService";

const instance = new HttpService( "umbraco/api/BasketStep/" );

export const getBasketProducts = () => instance.get( "GetBasketProducts" );

export const validateOrder = () => instance.get( "ValidateOrder" );

export const validateAddresses = () => instance.get( "ValidateAddresses" );

export const basketHasOrderLines = () => instance.get( "BasketHasOrderLines" );
